module.exports = __webpack_public_path__ + "img/search.d809f5cf.svg";